<template>
    <div>
        <p class="form-header">{{ $t('formHeader.formHeaderStep2') }}</p>
        <b-form class="form" novalidate @submit.prevent="nextStep">
            <div class="container-form">
                <div class="container-form-input">
                    <div class="mr-3 label">{{ $t('SubmissionFormStep2.department') }} *</div>
                    <multiselect
                        v-model="submission.departments"
                        :options="departmentOptions"
                        :multiple="true"
                        :close-on-select="false"
                        :placeholder="$t('SubmissionFormStep2.placeholder')"
                        class="select-box"
                        :class="[{'field-ok': validateField(submission.departments)}, {'field-error': validateField(submission.departments) === false}]"
                        :track-by="i18n('name')"
                        :custom-label="multiSelectLabel"
                        @input="validateField(submission.departments)"
                    />
                    <small
                        v-if="validateField(submission.departments) === false"
                        class="error"
                    >
                        {{ $t('errors.emptyFieldError') }}
                    </small>
                </div>
                <div class="container-form-input">
                    <div class="mr-3 label">{{ $t('SubmissionFormStep2.location') }} *</div>
                    <multiselect
                        v-model="submission.locations"
                        :options="locationOptions"
                        :multiple="true"
                        :close-on-select="false"
                        :placeholder="$t('SubmissionFormStep2.placeholder')"
                        class="select-box"
                        :class="[{'field-ok': validateField(submission.locations)}, {'field-error': validateField(submission.locations) === false}]"
                        :track-by="i18n('name')"
                        :custom-label="multiSelectLabel"
                        @input="validateField(submission.locations)"
                    />
                    <small
                        v-if="validateField(submission.locations) === false"
                        class="error"
                    >
                        {{ $t('errors.emptyFieldError') }}
                    </small>
                </div>
                <div class="container-form-input">
                    <div class="mr-3 label">
                        {{ $t('SubmissionFormStep2.priorPositionExperience') }} *
                    </div>
                    <b-form-input
                        v-model="submission.priorPositionExperience"
                        :number="true"
                        type="number"
                        :state="priorExperienceState()"
                        min="0"
                        max="99"
                        required
                        class="input-box"
                        size="lg"
                        @keydown="noMinus($event)"
                    />
                    <b-form-invalid-feedback class="error">
                        {{ showInvalidYearsError() ? $t('errors.invalidWorkExperience') : $t('errors.emptyFieldError') }}
                    </b-form-invalid-feedback>
                </div>
            </div>
            <div class="form-buttons">
                <button type="submit" class="submit">{{ $t('nextStep.nextStep') }}</button>
            </div>
        </b-form>
    </div>
</template>

<script>
    import locationService from '@/services/location-service'
    import departmentService from '@/services/department-service'
    import Multiselect from 'vue-multiselect'
    import i18nMixin from '@/mixins/i18n-mixin'
    export default {
        name: 'SubmissionFormStep2',
        components: { Multiselect },
        mixins: [ i18nMixin ],
        data() {
            return {
                submission: {},
                departmentOptions: [],
                locationOptions: [],
                noErrorsFlag: null
            }
        },
        created() {
            locationService.fetchAllLocations().then((res) => {
                this.locationOptions = res.content.sort(this.sortByOrder)
            })
            departmentService.fetchAllDepartments().then((res) => {
                this.departmentOptions = res.content.sort(this.sortByOrder)
            })
        },
        beforeUpdate() {
            this.locationOptions.sort(this.sortByOrder)
            this.departmentOptions.sort(this.sortByOrder)

        },

        methods: {
            nextStep() {
                this.validate()
                if(this.noErrorsFlag) {
                    this.$emit('update', this.submission)
                }
            },
            multiSelectLabel(option) {
                return option[this.i18n('name')]
            },
            validate() {
                this.noErrorsFlag = this.priorExperienceState() && this.validateField(this.submission.departments) && this.validateField(this.submission.locations)
                if ( this.noErrorsFlag === null) {
                    this.noErrorsFlag = false
                }
                return this.noErrorsFlag
            },
            showInvalidYearsError() {
                return this.submission.priorPositionExperience > 99 && this.submission.priorWorkExperience < 0
            },
            priorExperienceState() {
                const field = this.submission.priorPositionExperience
                if (this.noErrorsFlag === null) {
                    if (field === undefined) {
                        return null
                    }
                } else {
                    if (field === undefined) {
                        return false
                    }
                }
                if (field === null || field.length === 0 || this.showInvalidYearsError()) {
                    return false
                }
                return true
            },
            validateField(field) {
                if (this.noErrorsFlag === null) {
                    if (field === undefined) {
                        return null
                    }
                } else {
                    if (field === undefined) {
                        return false
                    }
                }
                if (field === null || field.length === 0) {
                    return false
                }
                return true
            },
            noMinus(e) {
                const minusASCII = 189
                if(e.keyCode === minusASCII) {
                    e.preventDefault()
                }
            },
            sortByOrder(a, b) {
                if (a.order === b.order) {
                    return this.sortByName(a,b)
                } else {
                    return b.order - a.order
                }
            }
        }
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
/* Multi select options */
.multiselect {
    height: 46px;
}

.multiselect__tags {
    font-size: 1rem;
    border: none;
}

.multiselect__select{
    position: absolute;
    top: 0;
    right: 0;
    width: 2.85rem;
    height: 2.85rem;
    background-image: url("~@/assets/icons/arrow-up.png");
    background-repeat: no-repeat;
    background-size: 2.75rem 100%;
    background-position: right;
}

.multiselect__input {
    width: 80%;
}

.multiselect--active
.multiselect__select {
    transform: rotate(180deg) translate(-5px, 0px);
    height: 2.87rem;
}

.multiselect__select::before {
    display: none;
}

.multiselect__option::after {
    background: #337ab7;
    color: #fff;
}

.multiselect__option--highlight {
    background: #7bc0fb;
    color: #fff;
}

.multiselect__option--selected {
    background: #337ab7;
    color: #fff;
}

.multiselect__tag {
    background: #337ab7;
}

.multiselect__tag-icon::after {
    color: #fff;
}

.multiselect__tag-icon:hover {
    background: rgb(97, 180, 243);
}
</style>

<style scoped>
.field-ok {
    box-shadow: 0 0 0 0.2rem rgb(40 167 69 / 25%);
}

.field-error {
    border-color: #dc3545 !important;
    box-shadow: 0 0 0 0.2rem rgb(220 53 69 / 25%);
}

.error {
    color: #dc3545;
}

.form-header {
    text-align: center;
    max-width: 540px;
    margin: 0 auto 1rem;
    line-height: 1.7rem;
    font-weight: 300;
}

.form {
    border-top: 1px solid #a0d4e9;
    max-width: 540px;
    margin: 0 auto;
}

.container-form {
    display: flex;
    flex-direction: column;
    width: 90%;
    margin: 0 auto 2rem;
    padding: 1.5rem 0;
    border-bottom: 1px solid #a0d4e9;
}

.container-form-input {
    margin-bottom: 0.75rem;
    max-width: 520px;
}

.label {
    color: #279fcf;
    margin-bottom: 0.5rem;
    font-family: 'Roboto', sans-serif;
}

.input-box {
    border-radius: 0;
    border-width: 2px;
    font-size: 1.0625rem;
}

.input-box:not(.is-invalid) {
    border-color: #a0d4e9;
}

.select-box,
.submit {
    border-radius: 0;
    border: 2px solid #a0d4e9;
}

.form-buttons {
    display: flex;
    justify-content: center;
}

.submit {
    background-color: #fff;
    padding: 10px 50px;
    margin: 0 auto;
    color: #0089c2;
    font-size: 18px;
}

.submit:hover {
    transition: all 0.15s ease-in-out;
    color: #fff;
    background: #a0d4e9;
}

@media screen and (min-width: 768px) {
    .form,
    .form-header {
        max-width: 730px;
    }

    .label {
        width: 20ch;
    }

    .container-form-input {
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        min-height: 127px;
        margin-bottom: 1rem;
        width: 100%;
        max-width: none;
    }
}

@media screen and (min-width: 992px) {
    .form,
    .form-header {
        max-width: 1100px;
    }

    .container-form {
        width: 100%;
        align-items: center;
    }

    .container-form-input {
        max-width: 730px;
    }
}

</style>

